import path from "path";
import runsApi from "@apis/runs";
import { ERRORS } from "@texts/errors";
import consoleLogFormatted from "consoleLogFormatted";
import { uniq } from "ramda";
import { executeCommandLine } from "./commandLineHelpers";
import { generateHistoryId } from "./common";
export const getDescribePath = ({ titlePath, title, project, rootDir, file, }) => titlePath.filter((item, index) => index !== 0 &&
    item !== title &&
    item !== project &&
    item !== path.relative(rootDir, file));
export const getCurrentCommitSha = () => executeCommandLine({
    command: "git rev-parse HEAD",
    messageOnError: ERRORS.onBegin.failedToGetCommitSha,
});
export const getCurrentCommitMessage = () => executeCommandLine({
    command: "git show-branch --no-name HEAD",
    messageOnError: ERRORS.onBegin.failedToGetCommitMessage,
});
export const getCurrentBranch = () => executeCommandLine({
    command: "git branch --show-current",
    messageOnError: ERRORS.onBegin.failedToGetBranch,
});
export const getCurrentAuthor = () => executeCommandLine({
    command: "git show -s --format='%an' HEAD",
    messageOnError: ERRORS.onBegin.failedToGetBranch,
});
export const getTestData = (test, rootDir) => {
    var _a;
    const { title, parent, location: { file }, } = test;
    const titlePath = test.titlePath();
    const project = (_a = parent.project()) === null || _a === void 0 ? void 0 : _a.name;
    const spec = path.relative(rootDir, file);
    const describe = getDescribePath({
        titlePath,
        title,
        project,
        rootDir,
        file,
    });
    const historyId = generateHistoryId({
        projectId: project !== null && project !== void 0 ? project : "",
        specName: spec,
        describeTitles: describe,
        testTitle: title,
    });
    return { title, describe, project, spec, historyId };
};
export const getInitializerData = ({ rootDir }, rootSuite) => uniq(rootSuite.allTests().map(test => getTestData(test, rootDir)));
export const sendHeartBeatSignal = async (ciBuildId) => {
    try {
        await runsApi.heartbeat(ciBuildId);
    }
    catch (error) {
        consoleLogFormatted.error(error.message);
        consoleLogFormatted.error(JSON.stringify(error, null, 4));
        consoleLogFormatted.redText(ERRORS.heartbeat.stopped);
        process.exit(1);
    }
};
//# sourceMappingURL=onBegin.js.map